export var maxBlockWidth = 672;